import { theme } from '../../../../shared/theme';

/** Matches ReservationEditDetailsSection layout label/value typography */
export const reservationEditLabelSx = {
    fontWeight: 800 as const,
    color: theme.palette.text.secondary,
    lineHeight: 1.35,
};

export const reservationEditValueSx = {
    color: theme.palette.text.primary,
    lineHeight: 1.35,
    wordBreak: 'break-word' as const,
};

export const reservationEditDescriptionSx = {
    color: theme.palette.text.secondary,
    fontSize: 13,
    lineHeight: 1.35,
    maxWidth: 640,
};
